import { useEffect, useState } from 'react';
import { useCurrentUser } from '../../../utils/auth/useCurrentUser';
export function useUserState(forcedUserState) {
    var _a = useState('loading'), userState = _a[0], setUserState = _a[1];
    var user = useCurrentUser();
    useEffect(function () {
        if (forcedUserState) {
            setUserState(forcedUserState);
        }
        else {
            setUserState(user
                ? (user.hasAccess && 'claimed') || 'unclaimed'
                : (user === undefined && 'loading') || 'loggedOut');
        }
    }, [user, forcedUserState]);
    return userState;
}
